import { Menu } from "@headlessui/react";

export const TableMenuItems = ({ children }) => (
  <Menu.Items className="absolute right-0 z-10 w-56 mt-2 origin-top-right bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none smooth-colors">
    <div className="py-1">{children}</div>
  </Menu.Items>
);
